import React, { useContext, useEffect, useState } from "react";
import styles from "./styles/BeneficiarySorry.module.css";
import img from "./styles/img/guard.svg";
import { LanguageContext } from "../../Context/changeLanguageProvider";

export function BeneficiarySorry() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.Beneficiary.BeneficiarySorry
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.Beneficiary.BeneficiarySorry);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.page_title}>{dublicatedcontent?.sorry}</div>
      <div className={styles.card}>
        <div className={styles.text_top}>
          <strong>{content.beneficiarySorryText1}</strong>
        </div>
        <div className={styles.text_middle}>
          <u>{content.beneficiarySorryText2}</u>
          <ol>
            <li>{content.beneficiarySorryText3}</li>
            <li>{content.beneficiarySorryText4}</li>
          </ol>
        </div>
        <div className={styles.text_bottom}>
          <div>{content.beneficiarySorryText5}</div>
          <strong>{content.beneficiarySorryText6}</strong>
        </div>
      </div>
      <div className={styles.img_container}>
        <img alt="" src={img} />
      </div>
    </div>
  );
}
